import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes,Route, Outlet} from "react-router-dom";
import { Navigate } from 'react-router-dom';

//main 
import LoginPage from '../../InterFaces/RouterOne/LoginPage'
import OneLandingPage from '../../InterFaces/RouterOne/OneLandingPage'
import OneGConf from '../../InterFaces/RouterOne/Assets/OneGConf';

//we may use it for indexDB
import OldUpdatePage from '../../InterFaces/RouterOne/Upload/updatePage'; 

// //Caisse Simple 
import CaissePage from "../../InterFaces/RouterOne/Caisse/caisseSimple"; 
import CaisseCodeBar from "../../InterFaces/RouterOne/Caisse/caisseCodeBar";
import CaisseStockStoped from "../../InterFaces/RouterOne/Caisse/CaisseStockStoped";
import CaisseStockPannier from "../../InterFaces/RouterOne/Caisse/caisseStockPannier";
import CaisseStock from "../../InterFaces/RouterOne/Caisse/caisseStock";

// Factures 
import MesFactures from '../../InterFaces/RouterOne/Factures/facture';
import FactureInfo from '../../InterFaces/RouterOne/Factures/factureInfo';

//Commandes
import CommandesInfo from '../../InterFaces/RouterOne/Commandes/commandesInfo';
import CommandesPage from '../../InterFaces/RouterOne/Commandes/commandesPage';
import AccepterCommande from '../../InterFaces/RouterOne/Commandes/accepterCommande'; 

//Commandes
import ReservationsInfo from '../../InterFaces/RouterOne/Reservations/commandesInfo';
import ReservationsPage from '../../InterFaces/RouterOne/Reservations/commandesPage';
import AccepterReservations from '../../InterFaces/RouterOne/Reservations/accepterCommande'; 

// //Recette
import Recette from "../../InterFaces/RouterOne/Recette/recette";
import DepenseRecette from '../../InterFaces/RouterOne/Recette/ajouterDepense';
import ImprimerRecette from '../../InterFaces/RouterOne/Recette/imprimerRecette';

import SettingPage from '../../InterFaces/RouterOne/Used/settingPage';
import UpdatePage from '../../InterFaces/RouterOne/Used/updatePage';


const RedirectingPage = () => {
    const OneIsLogged = localStorage.getItem(`${OneGConf.routerTagName}_LocalD`);
    return (<>
        {
            OneIsLogged ? <Navigate to={`/${OneGConf.routerName}/L`} /> : <Navigate to={`/${OneGConf.routerName}/logIn`}  />
        } 
</>);}

const routerOne = () => (
    <Route path="C" exact element={<Outlet />} >
            <Route path="" exact element={<RedirectingPage />} />
            <Route path="logIn" exact element={<LoginPage />} />
             <Route path="L" exact element={<Outlet />} >
                    <Route path="" exact element={<OneLandingPage />} />

                    <Route path="nv" exact element={<CaissePage />} />
                    <Route path="nvr" exact element={<CaisseCodeBar />} />
                    <Route path="nvsk" exact element={<CaisseStock />} />
                    <Route path="nvskp" exact element={<CaisseStockPannier />} />
                     
                    <Route path="cmd" exact element={<Outlet />} >
                        <Route path="" exact element={<CommandesPage />} />
                        <Route path="info/:CID" exact element={<CommandesInfo />} />
                        <Route path="accept" exact element={<AccepterCommande />} />
                    </Route>
                    
                    <Route path="rs" exact element={<Outlet />} >
                        <Route path="" exact element={<ReservationsPage />} />
                        <Route path="info/:CID" exact element={<ReservationsInfo />} />
                        <Route path="accept" exact element={<AccepterReservations />} />
                    </Route>

                    <Route path="ft" exact element={<Outlet />} >
                        <Route path="" exact element={<MesFactures />} />
                        <Route path="info/:FID" exact element={<FactureInfo />} />
                    </Route>

                    <Route path="rt" exact element={<Outlet />} >
                        <Route path="" exact element={<Recette />} />
                        <Route path="depenses" exact element={<DepenseRecette />} />
                        <Route path="imprimer" exact element={<ImprimerRecette />} />
                    </Route>

                    <Route path="ups" exact element={<OldUpdatePage />} />
                    <Route path="up" exact element={<UpdatePage />} />
                    <Route path="st" exact element={<SettingPage />} />
            </Route> 
    </Route>
)

export default routerOne 